export default __webpack_public_path__ + "static/psle-slay-screen-3-ceb52467a3b2abb985cf6b22d2c7c53b.png";